import classNames from 'classnames';
import * as React from 'react';

import {
  StaticBadge,
  StaticBadgeProps,
} from 'bones/design-system/components/badge/StaticBadge';
import {
  Icon,
  IconComponentType,
} from 'bones/design-system/components/icons/Icon';
import { Heading } from 'bones/design-system/components/typography/Heading';

export interface NavbarAsideProps {
  actions?: React.ReactNode;
  badgeProps?: Omit<StaticBadgeProps, 'size'>;
  children?: React.ReactNode;
  className?: string;
  icon?: IconComponentType;
  title: string;
}

export const NavbarAside: React.VFC<NavbarAsideProps> = ({
  actions,
  badgeProps,
  children,
  className,
  icon,
  title,
}) => (
  <div className={classNames(className, 'vb-navbar-aside')}>
    <div className="vb-navbar-aside-indicator">
      <div className="vb-navbar-aside-header">
        <div className="vb-navbar-aside-header-title">
          {icon ? <Icon IconComponent={icon} size="md" /> : null}
          <Heading size="md">{title}</Heading>
          {badgeProps ? (
            <StaticBadge
              size="xs"
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...badgeProps}
            />
          ) : null}
        </div>
        <div className="vb-navbar-aside-header-actions">{actions}</div>
      </div>
      {children}
    </div>
  </div>
);
